var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.showHome
    ? _c("div", { staticClass: "homecontainer" }, [
        _c("div", { staticClass: "subcontainer" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.search.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "search" }, [
                _c("img", {
                  attrs: { src: require("../../static/shipment-search.png") },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.id,
                      expression: "id",
                    },
                  ],
                  attrs: {
                    name: "Id",
                    type: "text",
                    placeholder: "Enter consignment number",
                    required: "",
                  },
                  domProps: { value: _vm.id },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.id = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "ripple", attrs: { type: "submit" } },
                  [_vm._v("Track shipment")]
                ),
              ]),
            ]
          ),
        ]),
      ])
    : _c(
        "div",
        [
          _c("tracking-search", {
            attrs: { connote: this.id, account: this.accountId },
          }),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "subcontainerheader" }, [
      _c("div", { staticClass: "heading" }, [_vm._v("Track shipments")]),
      _vm._v(" "),
      _c("div", { staticClass: "subheading" }, [
        _vm._v("Check the delivery status of a shipment"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }